import { axiosClient, axiosSSOConfigPrivate } from '../../api';
import { API_USERS_SETTINGS_SET_NOTIFICATIONS } from '../urls';

export const setOffNotificationSetting = async (value) => {
  const data = new FormData();
  data.append('name', 'off_notifications');
  data.append('value', value);

  return axiosClient.post(API_USERS_SETTINGS_SET_NOTIFICATIONS, data, axiosSSOConfigPrivate());
};
